import { TabPill } from 'types/tabs';

/* eslint-disable import/prefer-default-export */
export const mainTabs: TabPill[] = [
  { id: 'activities', label: 'Activities' },
  { id: 'notes', label: 'Notes' },
  { id: 'timeline', label: 'Timeline' },
  { id: 'attachments', label: 'Attachment' },
  { id: 'fee-collection', label: 'Fee Collection' }
];

export const paymentTableColumn = [
  { Header: 'Branch', accessor: 'branch', width: '13%' },
  { Header: 'Group/Notes', accessor: 'groupNotes', width: '13%' },
  { Header: 'Requested on', accessor: 'requestedOn', width: '13%' },
  { Header: 'Paid On', accessor: 'paidOn', width: '10%' },
  { Header: 'Settled On', accessor: 'settledOn', width: '10%' },
  { Header: 'Amount', accessor: 'amount', width: '10%' },
  { Header: 'Actions', accessor: 'actions', width: '8%' }
];

export const addToBranchGroupTableColumn = [
  { Header: 'Branch', accessor: 'branch', width: '13%' },
  { Header: 'Group', accessor: 'groupName', width: '13%' },
  { Header: 'Amount', accessor: 'amount', width: '10%' },
  { Header: 'Recurs', accessor: 'recurs', width: '13%' },
  {
    Header: 'Next request date',
    accessor: 'nextRequestDate',
    width: '13%'
  },
  { Header: 'Actions', accessor: 'actions', width: '8%' }
];

export const paymentCollectionTableColumn = [
  { Header: 'Branch', accessor: 'branch', width: '13%' },
  { Header: 'Group', accessor: 'groupName', width: '10%' },
  { Header: 'Group Amount', accessor: 'groupAmount', width: '16%' },
  {
    Header: 'Fee collection date',
    accessor: 'feeCollectionDate',
    width: '10%'
  },
  { Header: 'Start date', accessor: 'startDate', width: '10%' },
  { Header: 'Actions', accessor: 'actions', width: '8%' }
];
